// Small formatting helper extracted from DevopsDashboard.vue so it can be unit tested without
// mounting the component. Kept framework-free.

/**
 * Formats a number using the current locale, or renders an em dash when the value hasn't been
 * populated yet (e.g. a backend field that isn't deployed on this instance). This keeps a
 * missing metric visually distinct from a real "0", instead of showing a misleading zero.
 */
export function formatNumberOrDash(value: number | undefined | null, fractionDigits = 0): string {
  if (value === undefined || value === null) return '—';
  return new Intl.NumberFormat(undefined, {maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits}).format(value);
}

/**
 * Maps the locale-independent issue category ids the backend puts in
 * `charts.issue_type_distribution[].label` ("Bug"/"Feature"/"Requirement"/"Other", see
 * IssueCategory* in ee/services/dashboard/types.go) to display text.
 *
 * Unknown ids - and ids whose translation is missing from the locale bundle - are passed through
 * unchanged, so a mismatch between server and assets degrades to the raw English category instead
 * of an empty or "undefined" legend entry.
 */
export function localizeIssueCategory(category: string, locale: Record<string, string>): string {
  const localeKeys: Record<string, string> = {
    Bug: 'issueTypeBug',
    Feature: 'issueTypeFeature',
    Requirement: 'issueTypeRequirement',
    Other: 'issueTypeOther',
  };
  const key = localeKeys[category];
  if (!key) return category;
  return locale[key] || category;
}
